module.exports = __webpack_public_path__ + "static/media/mpayicon.5bceefd4.jpg";